/**
 * Convention-based atomization defaults (Step 2).
 *
 * The structural file filters once hard-coded a single companion subdir per
 * kind (`references/` for skills, `knowledge/` for agents). Real assets keep
 * helper material in other well-known subdirs — `scripts/`, `modes/`,
 * `templates/`, … — which the narrow filter silently dropped (see the
 * reference lint in {@link ./reference-lint.ts}).
 *
 * These allowlists generalize that: any of these subdirs, when present in an
 * asset's own directory, is captured wholesale. This is a "reverse search by
 * conventional directory name" — cheap, deterministic, no body parsing — and
 * covers the common cases without an LLM. Anything outside these conventions is
 * still surfaced by the lint and can be pulled in by reference closure (Step 3)
 * or the full-dir fallback (Step 4).
 *
 * Single source of truth: both the local-FS filters
 * ({@link ./builtin-providers.ts}) and the virtual-tree filters
 * ({@link ./tree-entries.ts}) read these, keeping store/local parity exact.
 */

/**
 * Subdirectories of a skill's directory captured wholesale when present.
 * `references/` stays first for historical primacy; the rest are the common
 * helper conventions (executable helpers, generated/static assets, sub-mode
 * docs, scaffolding templates).
 */
export const SKILL_COMPANION_DIRS: readonly string[] = [
  "references",
  "scripts",
  "assets",
  "templates",
  "modes",
  "bin",
  "data",
  "examples",
  "hooks",
];

/** Subdirectories of an agent's directory captured wholesale when present. */
export const AGENT_COMPANION_DIRS: readonly string[] = ["knowledge", "prompts", "examples"];
